<template>
  <modal
    v-show="isMobile"
    classes="app-banner"
    adaptive
    clickToClose
    :maxHeight="224"
    transition
    :shiftY="isSMobile ? 0.9 : 0.96"
    name="app-modal"
  >
    <section class="section">
      <asset-v3 dir="icons" name="thumb-parcelex-48@2x.png" class="thumb" />
      <div class="section-side">
        <span class="title">Parcelex</span>
        <h1 class="text">Continue pelo aplicativo para uma melhor experiência</h1>
      </div>
    </section>
    <div class="buttons-container">
      <button @click="goToApp" class="download-button">
        <span>Baixar aplicativo</span>
      </button>
      <button @click="closeModal()" class="not-now-button">
        <span>Agora não</span>
      </button>
    </div>
  </modal>
</template>

<script>
import storage from 'localforage';
import AssetV3 from '@/components/common/AssetV3.vue';

export default {
  data: () => ({
    wasClosedOnce: false,
  }),
  components: {
    AssetV3,
  },
  async created() {
    await storage.getItem('closed-app-modal').then((response) => {
      this.wasClosedOnce = response !== undefined ? response : false;
      if (
        this.isMobile
        && !this.wasClosedOnce
        && !this.isMobileSafari()
        && this.deviceCanGoToApp
      ) {
        this.$modal.show('app-modal');
      }
    });
  },
  computed: {
    isMobile() {
      let mobile = null;
      if (mobile !== null) return mobile;
      let check = false;
      (function isMobileFn(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
            a,
          )
          // eslint-disable-next-line no-useless-escape
          || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4),
          )
        ) {
          check = true;
        }
      }(navigator.userAgent || navigator.vendor || window.opera));
      mobile = check;
      return check;
    },
    deviceCanGoToApp() {
      const userAgent = navigator.userAgent || window.opera;

      if (/windows phone/i.test(userAgent)) {
        return false;
      }

      if (/android/i.test(userAgent)) {
        return true;
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true;
      }

      return false;
    },
    isSMobile() {
      return window.innerWidth <= 320;
    },
  },
  methods: {
    async closeModal() {
      await storage.setItem('closed-app-modal', true);
      this.$modal.hide('app-modal');
    },
    isMobileSafari() {
      return (
        navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)
      );
    },
    goToApp() {
      const userAgent = navigator.userAgent || window.opera;
      if (/android/i.test(userAgent)) {
        window.open('https://play.google.com/store/apps/details?id=br.com.parcelex.app', '_blank');
      }
      if (/iPad|iPhone|iPod/i.test(userAgent)) {
        window.open('https://apps.apple.com/br/app/parcelex/id6447885730', '_blank');
      }
    },
  },
};
</script>

<style lang="scss">
.app-banner {
  width: auto !important;
  margin: 0 12px !important;
  padding: 24px;
  background: white;
  z-index: 100;
  border-radius: 24px !important;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  height: fit-content !important;
  gap: 20px;
}

.app-banner > .section {
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
}

.app-banner > .section > .section-side {
  display: flex;
  flex-direction: column;
}

.app-banner > .section > .section-side > .title {
  color: #64748b;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.app-banner > .section > .section-side > .text {
  color: #0f172a;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.app-banner > .section > .thumb {
  height: 48px;
  width: 48px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.app-banner > .section > .close {
  position: absolute;
  border: none;
  padding: 2px;
  width: 28px;
  height: 28px;
  top: 0;
  right: 0;
  background: transparent;
}

.app-banner > .section > .close:hover {
  background: var(--gray-100);
}

.app-banner .buttons-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.app-banner .buttons-container .download-button {
  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 24px;
  border: none;
  height: 48px;
  background: #36a3ca;
  width: 100%;
}

.app-banner .buttons-container .not-now-button {
  display: flex;
  padding: 0;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 24px;
  border: none;
  height: 24px;
  background: transparent;
  width: 100%;
}

.app-banner .buttons-container .not-now-button > span {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  color: #278db3;
  line-height: 24px;
}

.app-banner .buttons-container .download-button > span {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  color: #ffffffff;
  line-height: 24px;
}
</style>
